<app-layout>
  <div class="container mt-4" style="max-width: 480px;">
    <h3>Impersonation</h3>
    <div class="form-group mt-3">
      <label>Employee</label>
      <input
        class="form-control"
        [(ngModel)]="inputName"
        [typeahead]="employees"
        typeaheadOptionField="nameEn"
        (typeaheadOnSelect)="onSelectEmployee($event)"
        [typeaheadScrollable]="true"
        [typeaheadOptionsInScrollableView]="5"
        [typeaheadMinLength]="0"
        placeholder="Search employee name..."
      />
    </div>
    <div *ngIf="errorMessage" class="alert alert-danger mt-2">{{ errorMessage }}</div>
    <button
      class="btn btn-primary mt-2"
      (click)="submit()"
      [disabled]="!selectedEmail || isLoading"
    >
      {{ isLoading ? 'Switching...' : 'Impersonate' }}
    </button>
  </div>
</app-layout>
